import getters from './getters'

import i18n from '../../../i18n'

const state = {
    mascotte: "",
    issues: [{
      id: 0,
      icon: 'wheelchair',
      title: i18n.t("components.dataGrid.accessibilityIssues.wheelchair.title"),
      text: i18n.t("components.dataGrid.accessibilityIssues.wheelchair.text"),
      color: "primary"
    },{
      id: 1,
      icon: 'low-vision',
      title: i18n.t("components.dataGrid.accessibilityIssues.vision.title"),
      text: i18n.t("components.dataGrid.accessibilityIssues.vision.text"),
      color: "secondary"
    },{
      id: 2,
      icon: 'desktop',
      title: i18n.t("components.dataGrid.accessibilityIssues.epilepsy.title"),
      text: i18n.t("components.dataGrid.accessibilityIssues.epilepsy.text"),
      color: "accent2"
    },{
      id: 3,
      icon: 'chalkboard-teacher',
      title: i18n.t("components.dataGrid.accessibilityIssues.learning.title"),
      text: i18n.t("components.dataGrid.accessibilityIssues.learning.text"),
      color: "status_critical"
    },{
      id: 4,
      icon: 'assistive-listening-systems',
      title: i18n.t("components.dataGrid.accessibilityIssues.auditory.title"),
      text: i18n.t("components.dataGrid.accessibilityIssues.auditory.text"),
      color: "accent3"
    }]
}

export default {
    state,
    getters
  }